import { EMAIL_VALIDATOR, mediumPassRegex } from "helpers/validators.js";

export const billingFields = {
  FirstName: {
    fieldKey: "FirstName",
    element: "input",
    type: "text",
    title: "FirstName",
    label: "signin-firstname-label",
    placeholder: "signin-firstname-placeholder",
    validation: {
      required: true,
      reg: /[^\n]+/,
      invalidMessage: "default-input-invalid-message",
    },
    containerClassName: "input-half-width",
  },
  LastName: {
    fieldKey: "LastName",
    element: "input",
    type: "text",
    title: "LastName",
    label: "signin-lastname-label",
    placeholder: "signin-lastname-placeholder",
    validation: {
      required: true,
    },
    containerClassName: "input-half-width",
  },
  Email: {
    fieldKey: "Email",
    element: "input",
    type: "email",
    title: "Email",
    label: "signin-email-label",
    placeholder: "signin-email-placeholder",
    validation: {
      required: true,
      invalidMessage: "invalid-email-text",
      reg: EMAIL_VALIDATOR,
    },
    externalValidationText: "mail-exist-tooltip-text",
    containerClassName: "input-half-width",
  },
  PhoneNumber: {
    fieldKey: "PhoneNumber",
    element: "input",
    type: "text",
    title: "PhoneNumber",
    label: "phonenumber-label",
    placeholder: "phonenumber-placeholder",
    validation: {
      required: true,
    },
    containerClassName: "input-half-width",
  },
  NameForReceipt: {
    fieldKey: "NameForReceipt",
    element: "input",
    type: "text",
    title: "NameForReceipt",
    label: "receipt-name-label",
    placeholder: "receipt-name-placeholder",
    containerClassName: "input-half-width",
  },
  IdNumber: {
    fieldKey: "IdNumber",
    element: "input",
    type: "text",
    title: "IdNumber",
    label: "id-number-label",
    placeholder: "id-number-placeholder",
    containerClassName: "input-half-width",
  },
  PaymentMethod: {
    fieldKey: "PaymentMethod",
    element: "radio",
    title: "IdNumber",
    label: "payment-method-label",
    optionsList: [
      { value: "creditcard", label: "creadit-card-label" },
      // {
      //   value: "paypal",
      //   icon:
      //     "https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-100px.png",
      // },
    ],
    validation: {
      required: true,
    },
  },
};

export const billingSingUpFields = {
  FirstName: {
    fieldKey: "FirstName",
    element: "input",
    type: "text",
    title: "FirstName",
    label: "signin-firstname-label",
    placeholder: "signin-firstname-placeholder",
    validation: {
      required: true,
      reg: /[^\n]+/,
      invalidMessage: "default-input-invalid-message",
    },
    containerClassName: "input-half-width",
  },
  LastName: {
    fieldKey: "LastName",
    element: "input",
    type: "text",
    title: "LastName",
    label: "signin-lastname-label",
    placeholder: "signin-lastname-placeholder",
    validation: {
      required: true,
    },
    containerClassName: "input-half-width",
  },
  Email: {
    fieldKey: "Email",
    element: "input",
    type: "email",
    title: "Email",
    label: "signin-email-label",
    placeholder: "signin-email-placeholder",
    validation: {
      required: true,
      invalidMessage: "invalid-email-text",
      reg: EMAIL_VALIDATOR,
    },
    externalValidationText: "mail-exist-tooltip-text",
    containerClassName: "input-half-width",
  },
  PhoneNumber: {
    fieldKey: "PhoneNumber",
    element: "input",
    type: "text",
    title: "PhoneNumber",
    label: "phonenumber-label",
    placeholder: "phonenumber-placeholder",
    validation: {
      required: true,
    },
    containerClassName: "input-half-width",
  },
  NameForReceipt: {
    fieldKey: "NameForReceipt",
    element: "input",
    type: "text",
    title: "NameForReceipt",
    label: "receipt-name-label",
    placeholder: "receipt-name-placeholder",
    containerClassName: "input-half-width",
  },
  IdNumber: {
    fieldKey: "IdNumber",
    element: "input",
    type: "text",
    title: "IdNumber",
    label: "id-number-label",
    placeholder: "id-number-placeholder",
    containerClassName: "input-half-width",
  },
  Password: {
    fieldKey: "Password",
    element: "input",
    type: "password",
    title: "Password",
    label: "signin-password-label",
    placeholder: "signin-password-placeholder",
    tooltip: {
      text: "signin-password-medium-tooltip-text",
    },
    validation: {
      required: true,
      invalidMessage: "signin-password-medium-tooltip-text",
      reg: mediumPassRegex,
    },
    showPasswordStrength: true,
    containerClassName: "input-half-width",
  },
  PasswordValidation: {
    fieldKey: "PasswordValidation",
    element: "input",
    type: "password",
    title: "PasswordValidation",
    label: "signin-password-validation-label",
    placeholder: "signin-password-validation-label",
    hidePassStrength: true,
    validation: {
      required: true,
      invalidMessage: "signin-password-medium-tooltip-text",
      reg: /[^\n]+/,
    },
    containerClassName: "input-half-width",
  },
  PaymentMethod: {
    fieldKey: "PaymentMethod",
    element: "radio",
    title: "IdNumber",
    label: "payment-method-label",
    optionsList: [
      { value: "creditcard", label: "creadit-card-label" },
      // {
      //   value: "paypal",
      //   icon:
      //     "https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-100px.png",
      // },
    ],
    validation: {
      required: true,
    },
  },
};
